import { FC, PropsWithChildren } from 'react';
import { CircleSpinner } from 'ui/spinner';
import { TriggerProps } from '../types';
import { StyledTriggerButton } from './TriggerButton.styles';

export const DATA_TEST = {
  loadingButton: 'queryBuilder-loading-trigger-button',
};

export const LoadingTriggerButton: FC<PropsWithChildren<Partial<TriggerProps>>> = (props) => (
  <StyledTriggerButton
    id="queryBuilder-trigger-loading-button"
    type="button"
    data-test={DATA_TEST.loadingButton}
    data-loading
    data-disabled
    data-empty
  >
    <CircleSpinner size={16} isColorInherited />
  </StyledTriggerButton>
);
